import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Blanket = React.forwardRef((_a, ref) => {
    var { canClickThrough, isTinted, onBlanketClicked, className } = _a, props = __rest(_a, ["canClickThrough", "isTinted", "onBlanketClicked", "className"]);
    const onClick = canClickThrough ? undefined : onBlanketClicked;
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('blanket', className, {
            'blanket--tinted': isTinted,
            'blanket-through': canClickThrough,
        }), onClick: onClick })));
});
Blanket.displayName = 'Blanket';
export { Blanket };
//# sourceMappingURL=Blanket.js.map